export default "__VITE_ASSET__0f8753e8__"